import * as Yup from 'yup';

const sensorSchema = Yup.object({
  type: Yup.string().required('Please choose an option.'),
  sensorEui: Yup.string()
    .required('Please fill out this field.')
    .matches(
      /^[a-zA-Z0-9_-]+$/,
      'Only latin letters, numbers, dash (-) and underscore (_) are allowed',
    ),
  sensorKey: Yup.string()
    .required('Please fill out this field.')
    .transform((v) => (v || '').replace(/-/g, '').trim())
    .matches(/^[0-9A-Fa-f]{16}$/, 'Key must be 16 hex characters.'),
});

const zoneSchema = Yup.object({
  name: Yup.string().required('Please fill out this field.'),
  plantType: Yup.string().required('Please choose an option.'),
  plantName: Yup.string().required('Please choose an option.'),
  soilType: Yup.string().required('Please choose an option.'),
  sensors: Yup.array().of(sensorSchema),
});

const objectSchema = Yup.object({
  name: Yup.string().required('Please fill out this field.'),
  file: Yup.mixed().nullable(),
  zones: Yup.array().of(zoneSchema).min(1, 'At least one zone is required'),
  sensors: Yup.array().of(sensorSchema),
});

export const validationSchemaStepTwo = Yup.object({
  details: Yup.array()
    .of(objectSchema)
    .min(1, 'At least one object is required')
    .test('at-least-one-sensor', 'At least one sensor must be added before saving', (details) => {
      if (!details) return false;
      return details?.some(
        (obj) =>
          (obj.sensors && obj.sensors.length > 0) ||
          (obj.zones && obj.zones?.some((zone) => zone.sensors && zone.sensors.length > 0)),
      );
    }),
});
